"use strict";

import { Swiper, Pagination, Autoplay } from "swiper";

const initializeBannerCarousel = () => {
    if (!window.heroBanerCarouselInitialized) {
        const carousels = $(".hero-banner-carousel-glide");

        carousels.each((index, carousel) => {
            const selector     = "." + $(carousel).data().id + " .swiper";
            const timer        = $(carousel).data().timer;
            const $firstBanner = $(carousel).find(".banner").first();
            const $firstImage  = $firstBanner.find("img").first();

            if ($firstImage.length) {
                $firstBanner.addClass("banner--lcp-priority");
                $firstBanner.attr("data-lcp-priority", "true");
                $firstImage.attr({
                    loading: "eager",
                    fetchpriority: "high",
                    decoding: "async"
                });
                $firstImage.css({ opacity: 1 });
                $firstImage.closest("picture").addClass("banner-image-loading--lcp").css({
                    "background-image": "none",
                    animation: "none"
                });
            }

            new Swiper(selector, {
                loop: true,
                autoplay: {
                    delay: +timer,
                    pauseOnMouseEnter: true
                },
                lazyPreloadPrevNext: 1,
                modules: [Pagination, Autoplay],
                parallax: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    10000: {
                        slidesPerView: 1
                    },
                },
            });
        });

        window.heroBanerCarouselInitialized = true;
    }
};

export default initializeBannerCarousel;
